/**
 * THE HELP REQUEST'S CLOSED LISTS — plan-019 DOM (design §31.3.2, §31.3.6; ADR 0068, proposed; glossary §6.33).
 *
 * Kept apart from the state machine (`./request.ts`, which raises a taxonomy error) so the protocol guards — and so the
 * widget's launcher chunk — can read the kinds without importing anything outside `packages/domain/src/help`.
 * Migration 0153's CHECKs list the same sets.
 */
/** `help_request.kind`. A help request is never a ticket and never a `support_note` (glossary §6.33). */
export const HELP_REQUEST_KIND = ["feedback", "support"];
/** `help_request.state`; moves only by `nextHelpRequestState` (`./request.ts`). */
export const HELP_REQUEST_STATE = ["new", "in_progress", "answered", "closed"];
/**
 * `help_request.origin`. Only the api writes `help_request` (design §31.0.3 D2): the person sends `widget_form`,
 * `assistant_offered` (after an `offer` frame) or `person_unavailable` (after `no_person`) from the panel; the operator
 * api writes `operator_created` when an operator ends a conversation with a request.
 */
export const HELP_REQUEST_ORIGIN = ["widget_form", "assistant_offered", "person_unavailable", "operator_created"];
/** The origins a person may send (`POST /v1/help/requests`, `POST /v1/public/help/requests`). */
export const HELP_REQUEST_PERSON_ORIGIN = ["widget_form", "assistant_offered", "person_unavailable"];
/** `help_request_reply.widget_delivery`: shown in a signed-in person's "Your messages", or not applicable (anonymous). */
export const HELP_REQUEST_REPLY_WIDGET_DELIVERY = ["in_widget", "not_applicable"];
/**
 * `help_request_reply.mail_delivery` (design §31.0.3 D3): `pending` → `queued` (the worker inserted the `mail_message`)
 * | `not_possible_mail_off`; `not_possible_no_address` and `not_requested` are written final. Sent and failed are read
 * from the `mail_message` row, never copied here.
 */
export const HELP_REQUEST_REPLY_MAIL_DELIVERY = [
    "pending",
    "queued",
    "not_possible_mail_off",
    "not_possible_no_address",
    "not_requested",
];
export function isHelpRequestKind(value) {
    return value === "feedback" || value === "support";
}
//# sourceMappingURL=request-kind.js.map